import {
  AppstoreOutlined,
  BarChartOutlined,
  SettingOutlined,
  ShoppingCartOutlined,
} from "@ant-design/icons";
import Header from "../../components/Header";
import TodayReport from "../../components/TodayReport/TodayReport";

const Posboard = () => {
  return (
    <div className="d-flex" style={{ height: "100vh" }}>
      {/* Sidebar and Header */}
      <Header />

      {/* Main Content */}
      <div
        style={{
          flex: "11 11 100%",
          padding: "20px",
          marginTop: "64px",
          overflow: "scroll",
        }}
      >
        <div>
          <TodayReport />
          <br />
          <div className="col-12 r-shadow">
            <div className="row">
              <div className="col-12 mt-3 px-5">
                <span className="apps"> Point Of Sale </span>
              </div>
            </div>

            <div className="row px-5">
              <div className="col-12 mt-3 d-inline">
                <a href="/pos/orders" className="ico-cont">
                  <div className="icon">
                    <ShoppingCartOutlined style={{ fontSize: 36 }} />
                  </div>
                  <p>Orders</p>
                </a>

                <a href="/pos/products" className="ico-cont">
                  <div className="icon">
                    <AppstoreOutlined style={{ fontSize: 36 }} />
                  </div>
                  <p>Products</p>
                </a>

                <a href="/reporting/sales-details" className="ico-cont">
                  <div className="icon">
                    <BarChartOutlined style={{ fontSize: 36 }} />
                  </div>
                  <p>Reporting</p>
                </a>

                <a href="/pos/Categories/" className="ico-cont">
                  <div className="icon">
                    <SettingOutlined style={{ fontSize: 36 }} />
                  </div>
                  <p>Configuration</p>
                </a>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="container border mt-5" style={{ padding: "10px" }}>
          <div className="row mt-3">
            <div className="col-6">
              <h5>Point Of Sale</h5>
            </div>
            <div className="col-6">
              <input
                type="text"
                placeholder="Search..."
                className="form-control"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-6"></div>
            <div className="col-6">
              <div className="mt-2" style={{float: "right"}}>
                <a className="btn bd-lightgray" href="/"><i className="fa fa-filter" aria-hidden="true"></i> Filter</a>
                <a className="btn bd-lightgray" href="/"><i className="fa fa-bars" aria-hidden="true"></i> Group By</a>
                <a className="btn bd-lightgray" style={{marginRight: "28px"}} href="/"><i className="fa fa-star" aria-hidden="true"></i> Favorites</a>
                <span>1-4/4</span>
                <a className="btn" href="/">❮ </a>
                <a className="btn" href="/"> ❯</a>
                <a className="btn bd-lightgray" href="/"><i className="fa fa-th-large" aria-hidden="true"></i></a>
                <a className="btn bd-lightgray" href="/Postile" ><i className="fa fa-list-ul" aria-hidden="true"></i></a>
              </div>
            </div>
          </div>
        </div> */}

        <br />
        <div className="r-shadow">
          <div className="container">
            <div className="row">
              <div className="col-6 mt-2 pl-1 pr-0">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-12">
                        <div className="mt-2">
                          <div className="row">
                            <div className="col-6">
                              <h5 className="card-title">Shop</h5>
                            </div>
                            <div className="col-6">
                              <a
                                className="btn"
                                href="/"
                                style={{ float: "right" }}
                              >
                                <i
                                  className="fa fa-ellipsis-v"
                                  aria-hidden="true"
                                ></i>
                              </a>
                            </div>
                          </div>
                          <a className="btn db" href="/createorder">
                            Resume
                          </a>
                          <a className="btn" href="#">
                            Close
                          </a>
                          <br />
                          <a
                            className="btn"
                            href="#"
                            style={{ float: "right" }}
                          >
                            <i className="fa fa-user" aria-hidden="true"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Posboard;
